export default "__VITE_ASSET__BjJ9fyec__"